module.exports = __webpack_public_path__ + "img/DE05740.0b09d1e8.png";